import { FormGroupNumericInput } from "@omnia/shared/react/NumericInput";
import { FormGroupSelect } from "@omnia/shared/react/Select";
import { formatToReadable } from "@omnia/shared/utils/format";
import { HoldingData } from "./types";
import { Checkbox } from "@omnia/shared/react/checkbox";
import { Msg } from "@omnia/shared/react/Msg";
import { isHoldingValid } from "./validation";
import { useMemo } from "react";


const getMonthName = (month: number): string => {
    return new Date(2000, month - 1).toLocaleString("en-en", { month: "short" })
}

interface Props {
    data: HoldingData;
    onUpdate: (newData: Partial<HoldingData>) => void;
}

export function HoldingEditTabWeather({ 
    data, 
    onUpdate }: Props) {

    const handleRainfallChange = (month: number, newValue: number) => {
        // create a new copy of weather data, with the number updated
        const updatedWeather = data?.weatherData.map(d => {
            if (d.Month === month) {
                return { ...d, Rainfall: newValue };
            }
            return d;
        });

        onUpdate({ weatherData: updatedWeather });
    }

    const sortedMonths = useMemo(() => {
        return data?.weatherData 
            ? [...data.weatherData].sort((a, b) => a.Month - b.Month)
            : []
    }, [data?.weatherData])

    return (
    <>
        {data?.stations && <>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Post Town</label>
                        <input type="text" className="form-control" disabled={true} value={data.town?.Name} />
                    </div>
                </div>

                <div className="col-md-6">
                    <FormGroupSelect
                        className={data.customWeather ? '' : 'required'}
                        label={<Msg>Weather station</Msg>}
                        placeholder="Region"
                        disabled={!data.town || data.customWeather}
                        defaultLabel=""
                        options={data.townStations?.map((st) => ([st.Name, st.Name]) )} 
                        value={data.station?.Name} 
                        setValue={v => onUpdate({ station: data.townStations.find(s => s.Name === v)})}
                        invalid={!isHoldingValid('station', data)}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <b>Long-term average rainfall</b>
                    <br /><br />
                </div>
                <div className="col-md-6 text-right">
                    Annual rainfall : <b>{formatToReadable(data.annualRainfall, 0, '')}mm</b>
                    <br /><br />
                </div>

                <div className="col-md-12">
                    <div className="form-group">
                        <Checkbox
                            checked={data.customWeather}
                            setChecked={b => onUpdate({ customWeather: b})}
                        />
                        <Msg>Custom weather data</Msg>
                    </div>
                </div>
                {(data.town || data.customWeather) && sortedMonths.map(d => (
                    <div key={d.Month} className="col-md-3">
                        <FormGroupNumericInput label={`${getMonthName(d.Month)} (mm)`} 
                            className={data.customWeather ? 'required' : ''} 
                            disabled={!data.customWeather} 
                            min={0}
                            value={d.Rainfall} 
                            setValue={n => handleRainfallChange(d.Month, n)} 
                            invalid={!isHoldingValid(`rainfall${d.Month}`, data)}
                        />
                    </div>
                ))}

            </div>
            </>
        }

    </>)
}